@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/mixins/common" as m;
@use "styles/abstracts/variables" as v;

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 32px;
  margin-bottom: 16px;
}

.editBox {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  &.openInput {
    gap: 16px;
    flex: 1;
  }

  .name {
    @include t.text(14px, 22px, 600);
    color: v.$default-text-color;
  }

  .inputBox {
    width: 360px;
    max-width: 100%;

    @include m.media(v.$container-tablet) {
      width: 100%;
    }
  }

  .saveBtn {
    border-radius: 50%;
    flex-shrink: 0;
  }

  .editBtn {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    padding: 0;
  }
}

.actionsBox {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.iconBtn {
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  min-width: 32px;
  padding: 0;
  border-radius: 8px;

  svg {
    width: 20px;
    height: 20px;
  }
}
